import { render } from "./SubmitZeroAction.vue?vue&type=template&id=54b6aec8"
import script from "./SubmitZeroAction.vue?vue&type=script&lang=js"
export * from "./SubmitZeroAction.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__